import React from 'react';
import MemberList from '../components/Members/MemberList';

const Members = () => {
  return <MemberList />;
};

export default Members;
